/** Characters that break a CSV column (RFC 4180 specials) or, when leading, trigger a spreadsheet formula. */
const CSV_HOSTILE_CHARS = /[",\n\r]/;
const LEADING_FORMULA_CHAR = /^\s*[=+\-@]/;

/**
 * Guest names end up in the Export All Guests CSV, so a comma, quote or line break would
 * shift columns and a leading `=`/`+`/`-`/`@` is executed as a formula by Excel/Sheets (LGL-51).
 * Empty values are "safe" here — required-ness is a separate rule.
 */
export const isCsvSafeName = (value: string | undefined): boolean => !value || (!CSV_HOSTILE_CHARS.test(value) && !LEADING_FORMULA_CHAR.test(value));
